import { HttpError } from 'modules/http-client'
import { Action } from 'modules/store'

import { MultiselectActionPayload } from './types'

export const GET_MULTISELECT_DATA = '[multiselect] Get data'
export const GET_MULTISELECT_DATA_SUCCESS = '[multiselect] Get data success'
export const GET_MULTISELECT_DATA_FAILURE = '[multiselect] Get data failure'

export const GET_MULTISELECT_ONE = '[multiselect] Get one'
export const GET_MULTISELECT_ONE_SUCCESS = '[multiselect] Get one success'
export const GET_MULTISELECT_ONE_FAILURE = '[multiselect] Get one failure'

export const CLEAN_MULTISELECT_DATA = '[multiselect] Clean'

export class GetMultiselectDataAction implements Action {
  readonly type = GET_MULTISELECT_DATA
  constructor(public payload: MultiselectActionPayload) {}
}

export class GetMultiselectDataSuccessAction implements Action {
  readonly type = GET_MULTISELECT_DATA_SUCCESS
  constructor(public payload: { storeId: string; data: any[] }) {}
}

export class GetMultiselectDataFailureAction implements Action {
  readonly type = GET_MULTISELECT_DATA_FAILURE
  constructor(public payload: HttpError) {}
}

export class CleanMultiselectDataAction implements Action {
  readonly type = CLEAN_MULTISELECT_DATA
  constructor(public payload: string) {}
}

export type MultiselectActions =
  | GetMultiselectDataAction
  | GetMultiselectDataSuccessAction
  | GetMultiselectDataFailureAction
  | CleanMultiselectDataAction

export default MultiselectActions



// WEBPACK FOOTER //
// ./src/modules/forms/multiselect-adapter/multiselect-adapter.actions.ts